export default {
  path: '/',
  component: () => import('@/layouts/Auth.vue'),
  children: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Auth/PageLogin.vue'),
    },
    {
      path: '/forgot',
      name: 'forgot password',
      component: () => import('@/views/Auth/ForgotPassword.vue'),
    },
    {
      path: '/password/reset',
      name: 'reset password',
      component: () => import('@/views/Auth/ResetPassword.vue'),
    },
  ],
}
